"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = connectRouter;

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _hoistNonReactStatics = require("hoist-non-react-statics");

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};

// higher order component that injects the react-router router shape object (noormally available on context) as a prop into the overgiven component
function connectRouter(TargetComponent) {
    var ConnectRouterContextHOC = function (_Component) {
        _inherits(ConnectRouterContextHOC, _Component);

        function ConnectRouterContextHOC() {
            _classCallCheck(this, ConnectRouterContextHOC);

            return _possibleConstructorReturn(this, Object.getPrototypeOf(ConnectRouterContextHOC).apply(this, arguments));
        }

        _createClass(ConnectRouterContextHOC, [{
            key: "render",
            value: function render() {
                return React.createElement(TargetComponent, __assign({ router: this.context.router }, this.props));
            }
        }]);

        return ConnectRouterContextHOC;
    }(_react.Component);
    // supply the required context... (must be made this way for es6 classes)


    ConnectRouterContextHOC.contextTypes = {
        router: _react.PropTypes.object.isRequired
    };
    // apply hoistStatics via hoist-non-react-statics here (copies static props, e.g. contextTypes)
    return (0, _hoistNonReactStatics2.default)(ConnectRouterContextHOC, TargetComponent);
}
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/decorators/connectRouter.tsx
 ** module id = 156
 ** module chunks = 0
 **/